import { render, staticRenderFns } from "./school-info.vue?vue&type=template&id=709861ee&"
import script from "./school-info.vue?vue&type=script&lang=js&"
export * from "./school-info.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports